export const TRANSACTION_TYPE = {
  EARLY_BIRD: 1,
  RAF: 2,
};

const _TRANSACTION_TYPE_DESCRIPTION_MAP = {};
_TRANSACTION_TYPE_DESCRIPTION_MAP[TRANSACTION_TYPE.EARLY_BIRD] = 'Early Bird';
_TRANSACTION_TYPE_DESCRIPTION_MAP[TRANSACTION_TYPE.RAF] = 'Refer-A-Friend';

export const TRANSACTION_TYPE_DESCRIPTION_MAP = _TRANSACTION_TYPE_DESCRIPTION_MAP;

const refTypeList = [];
Object.keys(TRANSACTION_TYPE).forEach((type) => {
  const id = TRANSACTION_TYPE[type];
  refTypeList.push({
    id,
    name: _TRANSACTION_TYPE_DESCRIPTION_MAP[id],
  });
});

export const TRANSACTION_TYPE_LIST = refTypeList;
